import { ActivityIndicator, toast } from '@kontentino/ui';
import { showToast } from 'app/hooks/useToast';
import type { TFunction } from 'i18next';

export function getAnalyticsReportGeneratingToastId(runId: number): string {
  return `analytics-report-generating-${runId}`;
}

export function showAnalyticsReportGeneratingToast(
  t: TFunction,
  runId: number,
): void {
  showToast(
    <div
      className="tw-flex tw-items-center tw-gap-3"
      data-cy={`analytics-reports_generating-toast-${runId}`}
    >
      <ActivityIndicator className="tw-h-5 tw-w-5 tw-shrink-0" />
      <div className="tw-flex tw-flex-col tw-gap-1">
        <span className="tw-text-sm tw-font-semibold tw-leading-4">
          {t('analyticsReports.generatingReport', {
            defaultValue: 'Generating report',
          })}
        </span>
        <span className="tw-text-sm tw-leading-4 tw-opacity-80">
          {t('analyticsReports.generatingReportInfo', {
            defaultValue: 'Your report is being generated.',
          })}
        </span>
      </div>
    </div>,
    'default',
    {
      id: getAnalyticsReportGeneratingToastId(runId),
      duration: Infinity,
    },
  );
}

export function dismissAnalyticsReportGeneratingToast(runId: number): void {
  toast.dismiss(getAnalyticsReportGeneratingToastId(runId));
}
